const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const API_URL = '/queue';

const handleError = async (response, fallbackMessage = "حدث خطأ غير متوقع") => {
    let message = fallbackMessage;
    try {
        const data = await response.json();
        message = data?.message || data?.error || fallbackMessage;
    } catch (_) {
        try {
            const text = await response.text();
            message = text || fallbackMessage;
        } catch (_) {}
    }

    console.error(`API Error [${response.status}]: ${message}`);
    throw new Error(message);
};

export const reserveTurnInQueue = async (token, queueId) => {
    const response = await fetch(`${BASE_URL}${API_URL}/turn`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ queueId }),
    });

    if (!response.ok) {
        await handleError(response, "حدث خطأ أثناء حجز الدور");
    }

    return await response.json();
};

export const getQueueDetails = async (queueId) => {
    const response = await fetch(`${BASE_URL}${API_URL}/${queueId}`);

    if (!response.ok) {
        await handleError(response, "حدث خطأ أثناء تحميل تفاصيل الطابور");
    }

    return await response.json();
};

export const getMyTurn = async (token, queueId) => {
    const response = await fetch(`${BASE_URL}${API_URL}/turn?queueId=${queueId}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
    });

    if (!response.ok) {
        await handleError(response, "حدث خطأ أثناء تحميل بيانات الدور");
    }

    return await response.json();
};
